import React from 'react'

const ProductCardDescription = ({
  code,
  productName,
  supplierName,
  description,
  itemAction,
}) => {
  return (
    <div
      className="product-card-description-box"
      style={{ cursor: itemAction ? 'pointer' : '' }}
      onClick={itemAction}
    >
      <div className="product-card-name">{code}</div>
      <div className="product-card-name">{productName}</div>
      <p className="product-card-description">{description}</p>
      <div className="product-card-supplier">{supplierName}</div>
    </div>
  )
}

export default ProductCardDescription
